import { render, staticRenderFns } from "./top-section.vue?vue&type=template&id=51ed8d15&scoped=true&"
import script from "./top-section.vue?vue&type=script&lang=js&"
export * from "./top-section.vue?vue&type=script&lang=js&"
import style0 from "./top-section.vue?vue&type=style&index=0&id=51ed8d15&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ed8d15",
  null
  
)

export default component.exports